import React from "react";
import RecruiterNotificationsOverview from "./RecruiterNotificationsOverview";
import RecruiterNotificationsList from "./RecruiterNotificationsList";
import RecruiterLayerBlueprint from "components/blueprints/RecruiterLayerBlueprint";

function RecruiterNotificationsPage() {
  return (
    <div className="min-h-screen bg-gray-100 py-2">
      <div className="container mx-auto my-6 flex">
        <section id="left" className="w-1/4 pr-2">
          <RecruiterNotificationsOverview />
        </section>
        <section id="right" className="w-3/4 pl-2">
          <RecruiterNotificationsList />
        </section>
      </div>
    </div>
  );
}

export default RecruiterLayerBlueprint(RecruiterNotificationsPage);
